export default __webpack_public_path__ + "static/media/Logo_Trust_EEAST@3x.79e9e951.png";